import { render } from "./SplitView.vue?vue&type=template&id=a41f3a8e&scoped=true&ts=true"
import script from "./SplitView.vue?vue&type=script&lang=ts"
export * from "./SplitView.vue?vue&type=script&lang=ts"

import "./SplitView.vue?vue&type=style&index=0&id=a41f3a8e&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41f3a8e"]])

export default __exports__